import { Cell } from '@pelckmans/elementis/components/table';

import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@pelckmans/elementis/components/button';
import Filter from '@pelckmans/elementis/icons/filter';
import ModalContext from '../../../../../../contexts/ModalContext';
import ScorableItemFilterModal from '../../scorable-item-filter-modal/ScorableItemFilterModal';
import { TocNodeRowHeader } from '../hooks/useTableData';
import { useFilters } from '../../../context/filter-context/FilterContext';

interface Props {
  nodeRowGroups: TocNodeRowHeader[];
}

export default function ItemFilter({ nodeRowGroups }: Props) {
  const { t } = useTranslation();
  const { setSelectedTableItems } = useFilters();
  const { showModal } = useContext(ModalContext);

  function handleFilterScorableItemsClick() {
    showModal(
      <ScorableItemFilterModal
        id="scorable-item-filter-modal"
        nodeRowGroups={nodeRowGroups}
        onConfirm={setSelectedTableItems}
      />,
    );
  }

  return (
    <Cell.Header.Actions>
      <Button
        onClick={handleFilterScorableItemsClick}
        startIcon={<Filter data-testid="filter-scorable-item" />}
        prominence="neutral"
      >
        {t('ACTIONS.FILTER')}
      </Button>
    </Cell.Header.Actions>
  );
}
